<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p [innerHtml]="data.content"></p>
</div>
<div mat-dialog-actions>
  <button mat-button mat-raised-button (click)="okClick()" color="primary">Ok</button>
</div>
